<script>
import axios from 'axios'
import Vue from 'vue'
const sha1 = require('sha1')
//import Peer from 'peerjs'
import ApiOffline from '@/components/Api/ApiOffline'
let defaultTimeout = 1500 // Timeout para esperar a Axios a que responda antes de devolver error
let Api = new Vue({
  name: 'ApiWst',
  data() {
    return {
      appName: 'Haakon CMMS',
      servidor: 'https://app.tecnhos.com.mx:8082',
      servidorDefault: 'https://app.tecnhos.com.mx:8082',
      servidorDominioEstandar: '',
      //dominioMaestro: 'haakon.mx',
      cdn: 'https://app.tecnhos.com.mx/cdn',
      yo: {},
      WSTcolecciones: ['Producto', 'Etiqueta'],
      cache: {},
      usarCache: false,
      modoPersistente: false,
      defaultUser: 'admin@local',
      defaultPw: 'password',
      customTokenSource: '',
      localStorageDefaultKey: 'cmms.yo',
      modoProduccion: (process && process.env && process.env.NODE_ENV && process.env.NODE_ENV === 'production'),
      //modoProduccion: true,
      modoOffline: false,
      usarPrecache: false, //TODO Al hacer Login, esto permite configurar el modo Offline antes de recargar la app. Para que funcione, debemos hacer que la app busque híbridamente entre la BD local y la remota.
      //
      peer: null,
      conexionesExistentes: {}
    }
  },
  methods: {
    auth(entidad) {
      console.log("Autentificando", entidad.nombreLargo || entidad.email)
      this.yo = entidad
      return null
    },
    setServer(url, defaultUser, defaultPw) {
      this.servidor = url
      if (defaultUser)
        this.defaultUser = defaultUser
      if (defaultPw)
        this.defaultPw = defaultPw
      console.log("Configurado servidor de esta instancia", this.servidor, this.defaultUser)
      //return this.ping()
      return true
    },
    errorHandler(e) {
      let vm = this
      let text = ''
      if (e && e.text)
        text = ': ' + e.text;
      vm.error = 'Error' + text;
      setTimeout(function() {
        delete vm.error;
      }, 1000);
      //    reject(e || {});
    },
    async saveLocal(lugar, obj) {
      console.log("saveLocal", lugar, obj)
      if (typeof obj == 'object')
        localStorage.setItem(lugar, JSON.stringify(obj))
      else localStorage.setItem(lugar, obj)
      //
      if (typeof ApiOffline != 'undefined' &&
        lugar.split('.').length == 3 &&
        lugar.split('.')[2].length == 24
      ) {
        let coleccion = lugar.split('.')[1]
        let id = lugar.split('.')[2]
        console.log("Transformando savelocal a ApiOffline", coleccion, id)
        await ApiOffline.save(coleccion, obj)
      }
      return true
    },
    fetchLocal(lugar) {
      let r = null
      try {
        r = JSON.parse(localStorage.getItem(lugar))
      } catch (e) {
        r = localStorage.getItem(lugar)
      }
      if (typeof ApiOffline != 'undefined' &&
        lugar.split('.').length == 3 &&
        lugar.split('.')[2].length == 24
      ) {
        let coleccion = lugar.split('.')[1]
        let id = lugar.split('.')[2]
        let devolverObjeto = true
        r = ApiOffline.get(coleccion, id, devolverObjeto)
      }
      return r
    },
    deleteLocal(lugar) {
      console.log("deleteLocal", lugar)
      localStorage.removeItem(lugar)
    },
    esMovil() {
      var check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i
          .test(a) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
          .test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    wait(time) {
      time = time || defaultTimeout
      return new Promise(resolve => {
        setTimeout(_ => {
          console.log("wait " + time)
          resolve(true)
        }, time)
      })
    },
    ping(str) {
      str = str || this.servidor;
      let vm = this;
      return new Promise((resolve, reject) => {
        try {
          let tS = new Date().getTime()
          axios.get(str, {
            headers: {
              'wst-appkey': 'vueonic',
              'token': vm.token()
            }
          }).
          then(function(o) {
            if (o.data && typeof o.data.serialNumber)
              vm.uuid = o.data.serialNumber;
            o.delta = (new Date().getTime()) - tS
            resolve(o);
          }, function(e) {
            reject(e);
          });
        } catch (e) {
          console.error("EPING", e)
          reject(e)
        }
      })
    },
    async login(user, pass, dondeGuardarIdentidad, noReintentar) {
      user = user || ''
      pass = pass || ''
      dondeGuardarIdentidad = dondeGuardarIdentidad || this.localStorageDefaultKey
      noReintentar = noReintentar && true ? true : false
      if (!this.modoOffline) {
        console.log("LOGIN", user, dondeGuardarIdentidad)
        console.log("Guardando identidad en ", dondeGuardarIdentidad)
        if (dondeGuardarIdentidad != this.localStorageDefaultKey) {
          this.customTokenSource = dondeGuardarIdentidad
        }
        let passOriginal = pass || ''
        if (pass.length != 40)
          pass = sha1(pass || '')
        let vm = this
        let resultado = null
        let error = null
        let jwtable = null
        console.info("Login", user, pass)
        try {
          console.log("Intentando auth directa...")
          let rJWT = await axios.post(vm.servidor + '/login', {
            email: user,
            password: pass
          })
          if (rJWT && rJWT.data && rJWT.data._id && rJWT.data.jwt) {
            vm.saveLocal(dondeGuardarIdentidad, rJWT.data)
            if (rJWT.data.servidor && rJWT.data.servidor != '' && rJWT.data.servidor.startsWith('http')) {
              vm.saveLocal('cmms.servidor', rJWT.data.servidor)
              vm.servidor = rJWT.data.servidor
              console.info("Encontrado servidor especificado", vm.servidor)
            }
            // guardar contraseña maestra
            if (rJWT.data.rol && rJWT.data.rol == 'administrador') {
              console.log("Guardando contraseña maestra", (rJWT.data.email))
              this.saveLocal('cmms.wstDefaultUser', user)
              this.saveLocal('cmms.wstDefaultPw', pass)
            }
            resultado = rJWT.data
            console.info("AUTH+JWT", resultado.email, resultado.jwt.length)
          } else throw new Error('Credenciales incorrectas?')
        } catch (e) {
          console.warn('No se pudo auth directa. !Reintentando?', {
            noReintentar
          })
          if (noReintentar) {
            error = 'Credenciales no encontradas'
          } else {
            console.warn(e)
            try {
              // Si hubo exito en un inicio de sesion previo con una cuenta maestra (admin), usarla como proxy
              let defaultUser = this.defaultUser
              let defaultPw = this.defaultPw
              let previousDefaultUser = this.fetchLocal('cmms.wstDefaultUser')
              if (previousDefaultUser && previousDefaultUser.length > 0)
                defaultUser = previousDefaultUser
              let previousDefaultPw = this.fetchLocal('cmms.wstDefaultPw')
              if (previousDefaultPw && previousDefaultPw.length > 0)
                defaultPw = previousDefaultPw
              // Obtener un JWT
              jwtable = await this.login(defaultUser, defaultPw, dondeGuardarIdentidad, true)
              console.log("jwtable", defaultUser, defaultPw, jwtable)
              if (!(jwtable && jwtable.jwt)) {
                throw new Error({
                  error: 'Credenciales maestras incorrectas',
                  raw: jwtable
                })
              }
              /* else {
                Api.saveLocal('cmms.wstDefaultUser', defaultUser)
                Api.saveLocal('cmms.wstDefaultPw', defaultPw)
              }*/
              this.saveLocal(dondeGuardarIdentidad, jwtable)
              let jwt = jwtable.jwt
              // Buscar en la BD
              let resultsLegacy = await vm.find('usuario', ['email,eq,' + user, 'password,eq,' + passOriginal], {
                limit: 1
              })
              let resultsLegacy2 = await vm.find('cliente', ['email,eq,' + user, 'password,eq,' + passOriginal], {
                limit: 1
              })
              resultsLegacy = resultsLegacy.concat(resultsLegacy2)
              console.log("resultsLegacy", resultsLegacy)
              if (resultsLegacy && resultsLegacy[0] && resultsLegacy[0]._id) {
                console.info("AUTH+Legacy", resultsLegacy)
                // Permitir al usuario tener un token para entrar
                resultsLegacy[0].jwt = jwt
                //toast("Concedido JWT para", resultsLegacy[0].email)
                //
                Api.saveLocal(dondeGuardarIdentidad, resultsLegacy[0])
                resultado = resultsLegacy[0]
              } else {
                console.error("EAUTH", resultsLegacy);
              }
            } catch (e) {
              error = e
            }
          }
        }
        return new Promise((resolve, reject) => {
          setTimeout(async _ => {
            if (resultado && resultado._id) {
              console.log("CREDENCIALES", resultado)
              // Si está disponible info de una empresa, guardarla de una vez
              try {
                let empresaExistente = await Api.get('empresa') || []
                if (empresaExistente && empresaExistente[0])
                  vm.saveLocal('cmms.empresadb', empresaExistente[0])
                //
              } catch (e) {}
              resolve(resultado)
            } else {
              console.error("CREDENCIALES", resultado)
              reject({
                error: 'Error de autentificación',
                raw: error
              })
            }
          }, 200)
        })
      } else {
        return Promise.reject({
          error: 'Debe conectarse a Internet'
        })
      }
    },
    uuid() {
      // TODO remplazar primer mitad del UUID con algo característico del dispositivo o del nombre de la BD
      return 'xxxxxxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    dump(bd) {
      bd = bd || '' // TODO aislar base de datos en modo multibd
      console.error("EWARNDBDUMP", new Date());
      let vm = this;
      return new Promise((resolve, reject) => {
        let ruta = vm.servidor + '/dump';
        axios.post(ruta, null, {
          headers: {
            'wst-appkey': 'vueonic',
            'token': vm.token()
          }
        }).then(function(p) {
          let o = p.data || {};
          if (!o.error)
            resolve(o);
          else
            reject(o);
        })
      })
    },
    token() {
      let t = ''
      let dondeLeerIdentidad = (this.customTokenSource && this.customTokenSource != '') ?
        this.customTokenSource : this.localStorageDefaultKey
      try {
        let k = JSON.parse(localStorage.getItem(dondeLeerIdentidad))
        t = k.jwt || ''
        if (t == null || t == '')
          throw new Error('EHB3TOKEN ' + dondeLeerIdentidad)
      } catch (e) {
        // No se pudo recuperar el token
        let k = JSON.parse(localStorage.getItem('cmms.yo'))
        t = k ? k.jwt : ''
      }
      return t
    },
    get(modelo, id, anularTimeout, subset) {
      console.log('GET', modelo, id);
      modelo = modelo || "";
      id = id || "";
      anularTimeout = anularTimeout && true
      if (!this.modoOffline) {
        let vm = this
        return new Promise(async (resolve, reject) => {
          let desdeCache = false;
          let ruta = vm.servidor + "/get/" + modelo;
          if (id != "") {
            ruta += "/" + id;
          }
          ruta += '?ts=' + new Date().getTime()
          if (subset && typeof subset == 'object')
            ruta += '&subset=' + btoa(JSON.stringify(subset))
          //else {
          let options = {
            headers: {
              'wst-appkey': 'vueonic',
              'token': vm.token()
            }
          }
          if (id != '' && !anularTimeout && defaultTimeout != 0) {
            options.timeout = defaultTimeout
            //console.log("Timeout", id, options)
          }
          try {
            let o = await axios.get(ruta, options) //.then(function(o) {
            if (o && o.data) {
              if (!desdeCache)
                resolve(o.data);
              if (o.data._id) { // Guardar en cache el objeto individual
                if (!vm.cache[modelo])
                  vm.cache[modelo] = {};
                vm.cache[modelo][id] = o.data;
                //console.log("Cache app", modelo, o.data._id);
              } else
              if (
                o.data.length > 0 && vm.WSTcolecciones.indexOf(modelo) != -1 // Colección cacheable
                ||
                vm.tiempoCache != 0 // Cache habilitada desde servidor
              ) {
                if (!vm.cache[modelo])
                  vm.cache[modelo] = {};
                o.data.forEach(function(obj) {
                  if (obj._id)
                    vm.cache[modelo][obj._id] = obj;
                });
                if (vm.usarCache) {
                  console.log("Actualizando cache en dispositivo", modelo, o.data.length);
                  localStorage.setItem('cmms.' + modelo, JSON.stringify(o.data));
                }
              }
            } else {
              //reject(o);
              throw new Error('No hay datos para mostrar')
            }
            /*}, function(e) {
              vm.errorHandler(e);
              reject(e);
            });*/
            //}
          } catch (e) {
            console.error("EAPIGET " + modelo, e)
            reject(e)
          }
        })
      } else return ApiOffline.get(modelo, id)
    },
    find(modelo, params, adicional) {
      modelo = modelo || "";
      params = params || Array();
      adicional = adicional || Object();
      if (!this.modoOffline) {
        let vm = this;
        return new Promise((resolve, reject) => {
          let resultado = [];
          let enCache = false;
          let ruta = vm.servidor + "/get/" + modelo + "?";
          if (typeof params == 'string')
            params = [params]
          if (params.length > 0) {
            params.forEach(function(param) {
              if (typeof param == 'string')
                ruta += "filters[]=" + param + "&";
            })
          }
          if (typeof adicional.limit != 'undefined')
            ruta += "limit=" + adicional.limit + "&";
          if (typeof adicional.skip != 'undefined')
            ruta += "skip=" + adicional.skip + "&";
          if (typeof adicional.math != 'undefined')
            ruta += "math=" + adicional.math + "&";
          if (typeof adicional.sort != 'undefined') {
            for (let s in adicional.sort) {
              ruta += "sort=" + adicional.sort[s] + "&";
            }
          };
          if (typeof adicional.subset != 'undefined')
            ruta += "subset=" + btoa(JSON.stringify(adicional.subset)) + "&";
          // Determinar si la consulta fue hecha previamente
          let candidato = '';
          candidato = localStorage.getItem('wstRuta.' + btoa(ruta));
          if (candidato && candidato.startsWith('[') && candidato.length > 2 && vm.tiempoCache > 0) {
            enCache = true;
            let listaCache = JSON.parse(candidato);
            console.log("Consulta en caché. Rescatando.", listaCache.length);
            console.log(ruta);
            for (let c in listaCache) {
              let id = listaCache[c];
              if (vm.cache[modelo] && vm.cache[modelo][id])
                resultado.push(vm.cache[modelo][id]);
              else
                enCache = false;
            }
            console.warn("Cache", resultado);
            if (enCache)
              resolve(resultado);
          }
          // Hacer la consulta real
          try {
            axios.get(ruta, {
              headers: {
                'wst-appkey': 'vueonic',
                'token': vm.token()
              }
            }).
            then(function(o) {
              if (typeof o.data != 'undefined') {
                resultado = o.data;
                // Guardar en dispositivo
                if (vm.tiempoCache && vm.tiempoCache > 0) {
                  // Respondo a tu llamado, joven elfo
                  let res = [];
                  // Cache de objetos
                  resultado.forEach(function(obj) {
                    res.push(obj._id);
                    vm.saveCache(modelo, obj);
                  });
                  // Cache de peticion
                  let encRuta = btoa(ruta);
                  //localStorage.setItem('wstRuta.' + encRuta, JSON.stringify(res));
                }
                // Ya
                if (!enCache)
                  resolve(resultado);
              } else
                reject(o);
            }).catch(function(e) {
              reject(e);
            });
          } catch (e) {
            console.error("EAPIFIND", e)
            reject(e)
          }
        })
      } else {
        return ApiOffline.find(modelo, params, adicional)
      }
    },
    save(modelo, objeto, forzarbd) {
      console.log("Save", modelo, objeto)
      modelo = modelo || "";
      objeto = objeto || {};
      forzarbd = forzarbd && true;
      if (typeof objeto.__v != 'undefined')
        delete objeto.__v;
      if (typeof objeto.jwt != 'undefined')
        delete objeto.jwt
      if (!this.modoOffline || forzarbd) {
        let vm = this;
        if (!objeto.fecha)
          objeto.fecha = new Date().getTime()
        return new Promise((resolve, reject) => {
          if (objeto == null || modelo == '')
            reject("Debes especificar un modelo y un objeto a actualizar");
          let ruta = vm.servidor + "/upsert/" + modelo;
          if (!vm.modoPersistente) { // Guardado normal
            if (!objeto._id) { // Insertar
              axios.post(ruta, objeto, {
                headers: {
                  'wst-appkey': 'vueonic',
                  'token': vm.token()
                }
              }).
              then(function(o) {
                console.log("Insertado", o.data.objeto);
                vm.saveCache(modelo, o.data.objeto);
                resolve(o.data.objeto);
              }, function(e) {
                vm.errorHandler(e);
                reject(e);
              });
            } else { // Actualizar
              ruta += "/" + objeto._id;
              axios.put(ruta, objeto, {
                headers: {
                  'wst-appkey': 'vueonic',
                  'token': vm.token()
                }
              }).
              then(function(o) {
                console.log("Actualizado", o.data);
                vm.saveCache(modelo, o.data.objeto);
                resolve(o.data.objeto);
              }, function(e) {
                vm.errorHandler(e);
                reject(e);
              });
            }
          } else { // Guardado persistente
            console.log("Guardado persistente", modelo)
            if (!vm.cache[modelo]) {
              console.warn("Creando cache de objetos", modelo);
              vm.cache[modelo] = {};
            }
            if (!objeto._id) { // Insertar
              objeto._id = vm.uuid();
              console.warn("Asignando uuid", objeto._id);
              vm.cache[modelo][objeto._id] = objeto;
              resolve(objeto);
              axios.post(ruta, objeto, {
                headers: {
                  'wst-appkey': 'vueonic',
                  'token': vm.token()
                }
              }).
              then(function(o) {
                console.log("Insertado", o.data.objeto);
                //resolve(o.data.objeto);
              }, function(e) {
                //reject(e);
                setTimeout(function() {
                  vm.save(modelo, o.data.objeto); // Hazlo eternamente hasta que lo PINCHES GUARDES
                }, 2000);
              });
            } else { // Actualizar
              ruta += "/" + objeto._id;
              vm.cache[modelo][objeto._id] = objeto;
              resolve(objeto);
              axios.put(ruta, objeto, {
                headers: {
                  'wst-appkey': 'vueonic',
                  'token': vm.token()
                }
              }).
              then(function(o) {
                console.log("Actualizado", o.data);
                //resolve(o.data.objeto);
              }, function(e) {
                //reject(e);
                setTimeout(function() {
                  vm.save(modelo, objeto); // Hazlo eternamente hasta que lo PINCHES GUARDES
                }, 2000);
              });
            }
          }
        })
      } else return ApiOffline.save(modelo, objeto)
    },
    delete(modelo, id) {
      modelo = modelo || "";
      id = id || null;
      if (!this.modoOffline) {
        let vm = this
        //let vm = this; return new Promise((resolve,reject)=>{
        let ruta = vm.servidor + "/" + modelo + "/" + id;
        if (vm.cache && vm.cache[modelo] && vm.cache[modelo][id])
          delete vm.cache[modelo][id];
        vm.deleteCache(modelo, id);
        return axios.delete(ruta, {
          headers: {
            'wst-appkey': 'vueonic',
            'token': vm.token()
          }
        })
      } else return ApiOffline.delete(modelo, id)
    },
    deleteMulti(modelo, lista) {
      lista = lista || [];
      modelo = modelo || "";
      if (!this.modoOffline) {
        //let vm = this; return new Promise((resolve,reject)=>{
        let ruta = vm.servidor + "/multi/" + modelo + '/' + JSON.stringify(lista);
        lista.forEach(function(id) {
          vm.deleteCache(modelo, id);
        });
        return axios.delete(ruta, {
          headers: {
            'wst-appkey': 'vueonic',
            'token': vm.token()
          }
        })
      } else {
        return ApiOffline.deleteMulti(modelo, lista)
      }
    },

    // Upload y download
    upload(handler, devolver) {
      let vm = this
      devolver = devolver || ''
      handler = handler || ''
      if (!this.modoOffline) {
        return new Promise((resolve, reject) => {
          if (['', 'binario', 'base64'].indexOf(devolver) == -1)
            reject('Valor de devolución no valido ("", binario o base64)')
          else if (handler == '')
            reject('Debes especificar un query DOM en el primer argumento')
          var identificador = handler;
          let h = document.querySelector(identificador).files[0];
          console.log("Cargando archivo del identificador", identificador);
          var fr = new FileReader();
          if (devolver == 'base64')
            fr.readAsDataURL(h);
          else // if(devolver=='' || devolver=='binario')
            fr.readAsBinaryString(h);
          fr.onloadend = function() {
            let binario = fr.result
            console.log("Bin", handler, binario.length)
            let ruta = vm.servidor + '/upload'
            if (devolver != '')
              resolve(binario)
            else
              axios.post(ruta, {
                archivo: btoa(binario),
                tipo: h.type,
                nombre: h.name
              }, {
                headers: {
                  'wst-appkey': 'vueonic',
                  'token': vm.token()
                }
              }).then(o => {
                resolve(o.data.filename)
              }, e => {
                reject(e)
              })
          }
          console.info("FileReader", h);
        })
      } else {
        return Promise.reject({
          error: 'No se puede usar el CDN en modo Offline'
        })
      }
    },

    // Rotator
    rotator(foto) {
      let vm = this
      return new Promise((resolve, reject) => {
        if (foto.indexOf(vm.cdn) >= 0)
          foto = foto.replace(vm.cdn + '/', '')
        console.log("Pidiendo rotación de", foto)
        if (!foto || foto == '')
          reject({
            error: 'No fue especificada la foto a girar'
          })
        axios.post(vm.servidor + '/rotator', {
          img: foto
        }, {
          headers: {
            'wst-appkey': 'vueonic',
            'token': vm.token()
          }
        }).then(p => {
          if (p && p.data && p.data.nombre)
            resolve(p.data.nombre)
          else reject({
            error: 'No se pudo obtener la nueva imagen rotada',
            raw: p
          })
        }).catch(e => {
          reject({
            error: 'No se pudo recuperar la imagen rotada',
            raw: e
          })
        })
      })
    },

    // Thumbnailer
    thumbnailer(handler, ratio, nombre, tamano, devolver) {
      let vm = this
      devolver = devolver || ''
      ratio = ratio || 1
      nombre = nombre || ''
      tamano = tamano || 500
      return new Promise((resolve, reject) => {
        if (['', 'binario', 'base64'].indexOf(devolver) == -1)
          reject('Valor de devolución no valido ("", binario o base64)')
        var identificador = "#" + handler;
        let h = document.querySelector(identificador).files[0];
        console.log("Cargando archivo del identificador", identificador);
        var fr = new FileReader();
        if (devolver == 'base64')
          fr.readAsDataURL(h);
        else // if(devolver=='' || devolver=='binario')
          fr.readAsBinaryString(h);
        fr.onloadend = function() {
          let binario = fr.result
          console.log("Bin", handler, binario.length)
          let ruta = vm.servidor + '/thumbnailer'
          if (devolver != '')
            resolve(binario)
          else
            axios.post(ruta, {
              imagen: btoa(binario),
              tipo: h.type,
              nombre: nombre || h.name,
              tamano: tamano,
              ratio: ratio
            }, {
              headers: {
                'wst-appkey': 'vueonic',
                'token': vm.token()
              }
            }).then(o => {
              console.log("Thumbnailer?", o.data)
              resolve(o.data.url)
            }, e => {
              reject(e)
            })
        }
        console.info("FileReader", h);
      })
    },

    download(str) {
      let ruta = (str.indexOf('http') >= 0) ? this.servidor + '/download/' + str : str
      if (!this.modoOffline) {
        return axios.get(ruta, {
          headers: {
            'wst-appkey': 'vueonic',
            'token': vm.token()
          }
        })
      } else {
        return Promise.reject({
          error: 'No se puede usar el CDN en modo Offline'
        })
      }
    },
    downloadBase64(ruta) {
      let vm = this
      if (!this.modoOffline) {
        return new Promise((resolve, reject) => {
          vm.download(ruta).then(obj => {
            let header = 'data:application/binary;base64,'
            resolve(header + obj.data.data)
          }, err => {
            reject(err)
          })
        })
      } else {
        return Promise.reject({
          error: 'No se puede usar el CDN en modo Offline'
        })
      }
    },
    downloadForce(ruta) {
      let vm = this
      if (!this.modoOffline) {
        vm.downloadBase64(ruta).then(blob => {
          let a = document.createElement('a')
          a.href = blob
          a.download = ruta
          a.style.display = 'none'
          a.style.visibility = 'hidden'
          document.querySelector('body').appendChild(a)
          a.click()
        })
      } else {
        return Promise.reject({
          error: 'No se puede usar el CDN en modo Offline'
        })
      }
    },

    // Crypto
    cryptoCreate(identity, passphrase, length, saveInDb) {
      let ruta = this.servidor + '/crypto/create'
      return axios.post(ruta, {
        identity,
        passphrase,
        length,
        saveInDb,
        idAutor: (this.fetchLocal('cmms.yo')) || {}._id
      })
    },
    cryptoGrant(source, destination, files) {
      let ruta = this.servidor + '/crypto/create'
      return axios.post(ruta, {
        source,
        destination,
        files
      })
    },
    cryptoRequest(source, destination, files) {
      let ruta = this.servidor + '/crypto/request'
      return axios.post(ruta, {
        source,
        destination,
        files
      })
    },
    cryptoValidate(source, destination, files) {
      let ruta = this.servidor + '/crypto/validate'
      return axios.post(ruta, {
        source,
        destination,
        files
      })
    },
    cryptoLockFile(fileBase64, key, passphrase, source) {
      let ruta = this.servidor + '/crypto/lock'
      let authorId = null
      try {
        let yo = this.fetchLocal('cmms.yo')
        if (yo && yo._id)
          authorId = yo._id
      } catch (e) {}
      return axios.post(ruta, {
        source,
        key,
        passphrase,
        fileBase64,
        idAutor: (this.fetchLocal('cmms.yo')) || {}._id
      })
    },
    cryptoUnlockFile(fileBase64, key, passphrase) {
      let ruta = this.servidor + '/crypto/unlock'
      try {
        let yo = this.fetchLocal('cmms.yo')
        if (yo && yo._id)
          authorId = yo._id
      } catch (e) {}
      return axios.post(ruta, {
        fileBase64,
        key,
        passphrase,
      })
    },
    cryptoShareFile(fileBase64, idAutor, shareId) {
      let ruta = this.servidor + '/crypto/share'
      return axios.post(ruta, {
        fileBase64,
        idAutor,
        shareId
      })
    },

    // Email
    email(obj) {
      console.log("Enviando correo", obj)
      let vm = this
      if (!this.modoOffline) {
        return new Promise(async (resolve, reject) => {
          if (!obj.emailOrigen || !obj.nombreOrigen || !obj.mensaje || !obj.emailDestino)
            reject({
              error: 'Faltan datos',
              raw: "emailOrigen,nombreOrigen,mensaje,emailDestino"
            })
          else try {
            let ruta = this.servidor + "/email"
            axios.post(ruta, obj, {
              headers: {
                'wst-appkey': 'vueonic',
                'token': vm.token()
              }
            }).then(r => {
              resolve(r)
            }).catch(e => {
              reject(e)
            })
          } catch (e) {
            console.error("ECORREO", e)
            reject({
              error: "No se pudo enviar el correo",
              raw: e
            })
          }
        })
      } else {
        return Promise.reject({
          error: 'No se pueden enviar emails en modo Offline'
        })
      }
    },

    // libreofficetopdf
    async libreofficetopdf(archivo) {
      archivo = archivo || ''
      let ruta = this.servidor + '/libreofficetopdf'
      if (archivo == '')
        return Promise.reject({
          error: 'No fue especificado un archivo a convertir'
        })
      else
        return axios.post(ruta, {
          archivo
        })
    },

    // Funciones de cache
    saveCache(modelo, obj) {
      let vm = this
      if (modelo && obj) {
        console.log("Save cache", modelo, (obj._id || ''));
        if (vm.tiempoCache != 0 && modelo && obj._id && obj.fecha) {
          if (
            obj.fecha >= (new Date().getTime() - (vm.tiempoCache)) // Está en rango de tiempo
            ||
            vm.WSTcolecciones.indexOf(modelo) != -1 // La app requiere que sea cacheable
          ) {
            if (!vm.cache[modelo])
              vm.cache[modelo] = {};
            vm.cache[modelo][obj._id] = obj;
          }
        }
      }
    },
    deleteCache(modelo, id) {
      let vm = this
      if (modelo && id && vm.cache[modelo] && vm.cache[modelo][id])
        delete vm.cache[modelo][id];
    },

    // Servidor intercambiable
    cambiarServidor(url) {
      this.servidor = url
      let uurl = new URL(this.servidor)
      if (
        uurl.hostname != window.location.hostname &&
        this.modoProduccion && false
        //&& uurl.hostname != 'app.haakon.mx' // Permitir acceder a la API de Haakon desde aplicaciones no hospedades en el servidor Haakon
      ) {
        console.log("Cambiando hostname", window.location.hostname, uurl.hostname)
        this.servidor = this.servidor.replace(uurl.hostname, window.location.hostname).replace(uurl.protocol, window.location.protocol)
      }
      console.log("Cambiada la URL del servidor", this.servidor)
    },

    proxied(obj) {
      let vm = this
      let ruta = vm.servidor + '/proxied'
      let params = ['url', 'options', 'params']
      // params.REQUEST_TYPE
      for (let param of params)
        if (!obj[param])
          return Promise.reject('Falta el parámetro axios:', param)
      if (!this.modoOffline) {
        return axios.post(ruta, obj, {
          headers: {
            'wst-appkey': 'hummingbird3',
            'token': vm.token()
          }
        })
      } else {
        return Promise.reject({
          error: 'No se puede usar el proxy de aplicaciones en modo Offline'
        })
      }
    },
    qrcode(str) {
      console.log("QR", str)
      let vm = this
      let ruta = vm.servidor + '/qrcode'
      if (!this.modoOffline) {
        return axios.post(ruta, {
          cadena: str
        }, {
          headers: {
            'wst-appkey': 'hummingbird3',
            'token': vm.token()
          }
        })
      } else {
        return Promise.reject({
          error: 'No se puede usar el módulo QR en modo Offline'
        })
      }
    },
    getfile(modelo, id, campo, descargarComoBinario) {
      modelo = modelo || ''
      id = id || ''
      campo = campo || 'data'
      let binario = (descargarComoBinario == true) ? "1" : "0"
      let vm = this
      let ruta = vm.servidor + ['/getfile', modelo, id, campo, binario].join('/')
      console.log("getfile", ruta)
      if (!this.modoOffline) {
        return axios.get(ruta, {
          headers: {
            'wst-appkey': 'hummingbird3',
            'token': vm.token()
          }
        })
      } else {
        return Promise.reject({
          error: 'No se pudo recuperar el archivo'
        })
      }
    },
    //
    geolocate() {
      let y = Api.fetchLocal('cmms.yo') || {}
      let vm = this
      return new Promise(async (resolve, reject) => {
        if ('geolocation' in navigator && y && y._id) {
          navigator.geolocation.getCurrentPosition(async (pos) => {
              let c = {
                rol: y.rol || 'invitado',
                userid: y._id || '',
                lat: pos.coords.latitude,
                long: pos.coords.longitude,
                date: new Date().getTime(),
                route: window.location.hash
              }
              let u = await Api.save('geo', c)
              console.log("Guardado geolocalizacion", u)
              resolve(u)
            },
            (e) => {
              reject({
                error: 'No se pudo obtener la ubicación',
                raw: e
              })
            })
        } else {
          reject('No se pudo acceder al módulo de geolocalización')
        }
      })
    },

    // PeerJS
    obtenerPeerConfig() {
      let urlApi = new URL(this.servidor)
      let peerConfig = {
        host: urlApi.hostname,
        port: parseInt(urlApi.port) + 10,
        path: '/peerserver',
        secure: urlApi.protocol.indexOf('https') >= 0,
        debug: 2
      }
      return peerConfig
    },
    async crearPar() {
      let yoId = this.fetchLocal('cmms.yo')._id
      let par = new Peer(yoId, this.obtenerPeerConfig())
      console.log("crearPar?", yoId, par)
      return Promise.resolve(par)
    },
    async crearConexionPeer(idDestino) {
      let vm = this
      let yoId = this.fetchLocal('cmms.yo')._id
      console.log("peer crearPar", yoId, "=>", idDestino)
      try {
        if (!this.peer) {
          //this.peer = await this.crearPar()
          this.peer = new Peer(yoId, this.obtenerPeerConfig())
          console.log("peer par creado ", this.peer)
        }
        let conn = this.peer.connect(idDestino)
        //if (false)
        conn.on('open', _ => {
          conn.send('Hi!')
        })
        this.peer.on('connection', conn => {
          console.log("PeerJS connection", idDestino)
          conn.on('data', data => {
            vm.$emit('PeerJS.data.' + idDestino, data)
          })
          conn.on('open', _ => {
            vm.$emit('PeerJS.open', idDestino)
            console.log("peerjs open", idDestino)
            //conn.send(idDestino, 'peer hola tu')
          })
          if (!vm.conexionesExistentes[idDestino]) {
            vm.$on('PeerJS.send.' + idDestino, (msg) => {
              console.log("$on PeerJS.send." + idDestino, msg.length)
              conn.send(msg)
            })
            vm.conexionesExistentes[idDestino] = true
          }
        })
        this.peer.on('disconnect', _ => {
          console.error("peer Par desconectado", idDestino)
          vm.$off("PeerJS.send." + idDestino)
          while (vm.peer.disconnected)
            setInterval(_ => {
              vm.peer.reconnect()
            }, 5000)
          //vm.peer = null
        })
        console.info("Para recibir datos, usar $on PeerJS.data." + idDestino)
        return Promise.resolve(conn)
      } catch (e) {
        console.error("EPEER", e)
        return Promise.reject(e)
      }
    }

  },
  async created() {
    // Recuperar servidor de un inicio de sesion previo
    let servidor = this.fetchLocal('cmms.servidor')
    this.modoOffline = this.fetchLocal('cmms.modoOffline') || false
    console.log("Api de WanShiTong", {
      modoProduccion: this.modoProduccion,
      modoOffline: this.modoOffline
    })
    if (servidor && servidor.length > 0) {
      this.servidor = servidor
      console.log("Configurado servidor custom", this.servidor)
    }
    // Configurar servidor a origen externo si no viene de dominio
    // Si Hummingbird no corre desde su dominio, convertir la URL a la IP local
    // Esto solo aplica si no hay sesion iniciada.
    if (
      this.modoProduccion &&
      window.location.href.indexOf(this.servidorDominioEstandar) == -1 &&
      window.location.href.indexOf(this.dominioMaestro) == -1 &&
      // Una sesión iniciada ya estableció el dominio correcto.
      !(this.fetchLocal(this.localStorageDefaultKey) || {})._id
    ) {
      let hostname = window.location.hostname
      if (hostname == '0.0.0.0')
        hostname = 'localhost'
      //this.servidor = window.location.protocol + '//' + hostname + ':8082'
      this.servidorDefault = this.servidorDefault.replace('https:', window.location.protocol).replace(this.servidorDominioEstandar, hostname)
      this.servidor = this.servidorDefault
      console.log("configurando servidor desde fuera de la URL estandar (" + this.servidorDominioEstandar + ")", this.servidorDefault, this.servidor)
    }
    // Modo pruebas
    try {
      let modoPruebas = Api.fetchLocal('cmms.modoPruebas')
      if (modoPruebas && modoPruebas == true) {
        this.modoProduccion = false
        console.log("Forzado modo pruebas")
      }
    } catch (e) {}
    // Hacer un ping para comprobar que todo ande bien. Pero sólo hacia Internet.
    try {
      console.log("Ping?", this.servidor, this.servidorDefault)
      //if (window.location.hostname.indexOf('haakon.mx') >= 0)
      await this.wait(1000)
      let ping = await this.ping()
      console.log("Ping!", ping.status, (ping.data || {}).appName, ping.delta)
      if (ping.delta) {
        defaultTimeout = 1500 + (ping.delta)
        console.log("Ping: Configurado retraso de la red para la API", ping.delta, defaultTimeout)
      }
    } catch (e) {
      console.warn("Error al hacer PING de inicialización de WanShiTong")
      console.warn(e.response)
      if ((e.response || {}).status == 401) {
        let vm = this
        setTimeout(_ => {
          console.log("$emit esNecesarioHacerLoginNuevamente")
          vm.$emit('esNecesarioHacerLoginNuevamente', true)
        }, 2000)
      }
    }
  },
  beforeDestroy() {
    if (this.peer) {
      if (typeof this.peer.disconnect == 'function')
        this.peer.disconnect()
    } else {
      this.peer = null
    }
  }
})
window.Api = Api
export default Api
export {
  Api as ApiInstantiable
}
</script>
